"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _WebProfileContext = _interopRequireDefault(require("../../context/WebProfileContext"));
var _FallbackImage = _interopRequireDefault(require("./FallbackImage.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FallbackImage = _ref => {
  let {
    identifier = "fallback"
  } = _ref;
  const [profileData] = (0, _react.useContext)(_WebProfileContext.default);
  const {
    logos
  } = profileData || {};
  const css = (0, _FallbackImage.default)();
  const logo = (0, _react.useMemo)(() => {
    var _logos$find;
    return logos === null || logos === void 0 || (_logos$find = logos.find(item => (item === null || item === void 0 ? void 0 : item.identifier) === identifier)) === null || _logos$find === void 0 ? void 0 : _logos$find.filename;
  }, [identifier, logos]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.imageWrapper, "mco-fallback-image")
  }, logo && /*#__PURE__*/_react.default.createElement("img", {
    alt: "",
    className: css.image,
    src: logo
  }));
};
var _default = exports.default = FallbackImage;